import { z } from 'zod';
/**
 * Hangok.
 *
 * A hangokat FAJLBOL jatsszuk, es a fajlok a csomag reszei - nem CDN-rol
 * jonnek. Egy sajat uzemeltetesu rendszer nem kuld kerest idegen szerverre
 * minden csengetesnel, es tuzfal mogott, halozat nelkul is mukodnie kell.
 *
 * Korabban szintetizaltuk oket a Web Audio API-val. Az mukodott, de hallatszott
 * rajta: egy oszcillatorbol nem lesz kellemes csengohang, foleg nem zene.
 *
 * **Jogtisztasag** (a teljes lista: docs/11-credits.md):
 *  - a csengo- es ertesito hangok az Android Open Source Project keszletebol
 *    valok, **Apache-2.0** licenc alatt,
 *  - a varakozo zene Kevin MacLeod szerzemenye, **CC BY 4.0** alatt - ez
 *    nevmegjelolest KOVETEL, ezert a felhasznaloi feluleten is ott van
 *    (Beallitasok → Csengohang es zene).
 */
/** A hangfajlok gyokere. A `public/` alatt van, tehat a kiszolgalo adja. */
export const SOUND_BASE = '/sounds';
// ─── Ertesito hangok ──────────────────────────────────────────────────────────
export const notificationSounds = [
    'koppanas',
    'buborek',
    'harang',
    'kettos',
    'halk',
    'nincs',
];
export const notificationSoundSchema = z.enum(notificationSounds);
export const SOUND_LABELS = {
    koppanas: 'Koppanás',
    buborek: 'Buborék',
    harang: 'Harang',
    kettos: 'Kettős',
    halk: 'Halk',
    nincs: 'Néma',
};
/** A fajl utvonala, vagy `null`, ha nem szol semmi. */
export function notificationSoundUrl(name) {
    return name === 'nincs' ? null : `${SOUND_BASE}/ertesites/${name}.mp3`;
}
export const DEFAULT_SOUND = 'koppanas';
// ─── Csengohangok ─────────────────────────────────────────────────────────────
/**
 * Hivas-jelzesek.
 *
 * Az ertesito hangtol kulonboznek: azok egyszer szolnak, ezek ismetlodnek,
 * amig valaki fel nem veszi. Ezert dallamok, nem koppanasok - egy ismetlodo
 * koppanas par masodperc alatt idegesito.
 */
export const ringtones = ['puha', 'dallamos', 'klasszikus', 'diszkret', 'nincs'];
export const ringtoneSchema = z.enum(ringtones);
export const RINGTONE_LABELS = {
    puha: 'Puha',
    dallamos: 'Dallamos',
    klasszikus: 'Klasszikus',
    diszkret: 'Diszkrét',
    nincs: 'Néma',
};
export function ringtoneUrl(name) {
    return name === 'nincs' ? null : `${SOUND_BASE}/csengo/${name}.mp3`;
}
export const DEFAULT_RINGTONE = 'puha';
// ─── Varakozo zene ────────────────────────────────────────────────────────────
/**
 * Amit egyedul hallunk a huddle-ben.
 *
 * Egy ures hivas nyomaszto: nem derul ki, hogy el-e a kapcsolat, vagy csak
 * nincs ott meg senki. Halk zene ezt oldja fel - jelzi, hogy minden mukodik,
 * es kellemesebbe teszi a varakozast.
 */
export const holdMusicOptions = ['lounge', 'bossa', 'vermouth', 'nincs'];
export const holdMusicSchema = z.enum(holdMusicOptions);
export const HOLD_MUSIC_LABELS = {
    lounge: 'Lounge',
    bossa: 'Bossa nova',
    vermouth: 'Vermouth',
    nincs: 'Néma',
};
/** A szerzo es a mu neve - a CC BY licenc KOVETELI a megjeleniteset. */
export const HOLD_MUSIC_CREDITS = {
    lounge: 'Backbay Lounge — Kevin MacLeod (incompetech.com), CC BY 4.0',
    bossa: 'Bossa Antigua — Kevin MacLeod (incompetech.com), CC BY 4.0',
    vermouth: 'Sweeter Vermouth — Kevin MacLeod (incompetech.com), CC BY 4.0',
    nincs: null,
};
export function holdMusicUrl(name) {
    return name === 'nincs' ? null : `${SOUND_BASE}/zene/${name}.mp3`;
}
export const DEFAULT_HOLD_MUSIC = 'lounge';
// ─── Visszacsengetes ──────────────────────────────────────────────────────────
/**
 * Amit MI hallunk, amig a masik felveszi.
 *
 * NEM ugyanaz, mint a csengohang: az annak szol, AKIT hivunk. A kettonek
 * kulonboznie kell, kulonben nem derul ki, melyik iranyu hivasrol van szo -
 * es epp az a helyzet a legrosszabb, amikor az ember nem tudja, most o var
 * valakire, vagy ot varja valaki.
 *
 * ─── Miert nincs hozza hangfajl? ────────────────────────────────────────────
 *
 * Mert a visszacsengetes TERMESZETE SZERINT tiszta hang, meghatarozott utemmel
 * - a telefonkozpont is pontosan ezt allitja elo. Egy felvetel csak rosszabb
 * masolat lenne belole, ket-harom szazezer bajton es egy ujabb licencen.
 *
 * (A csengohangoknal es a zenenel forditva all: ott a dallam a lenyeg, azt
 * pedig oszcillatorbol tenyleg nem lehet.)
 */
export const ringbacks = ['magyar', 'amerikai', 'gyors', 'zene', 'nincs'];
export const ringbackSchema = z.enum(ringbacks);
export const RINGBACK_LABELS = {
    magyar: 'Csörgés (magyar)',
    amerikai: 'Csörgés (amerikai)',
    gyors: 'Gyors csörgés',
    zene: 'Várakozó zene',
    nincs: 'Néma',
};
export const RINGBACK_PATTERNS = {
    // Magyar/europai szabvany: 425 Hz, 1,25 mp jel - 3,75 mp szunet.
    magyar: { frequencies: [425], onMs: 1250, offMs: 3750 },
    // Eszak-amerikai: 440 + 480 Hz egyutt, 2 mp jel - 4 mp szunet.
    amerikai: { frequencies: [440, 480], onMs: 2000, offMs: 4000 },
    // Surubb utem annak, aki hamarabb akar felfigyelni ra.
    gyors: { frequencies: [425], onMs: 900, offMs: 1100 },
};
export const DEFAULT_RINGBACK = 'magyar';
/**
 * Ennyi egyedul toltott ido utan indul a zene.
 *
 * Elobb nem: aki most inditotta a hivast, meg varja a masikat, es egy azonnal
 * beugro zene tolakodo lenne. Fel perc utan viszont mar nem varakozas, hanem
 * uresjarat.
 */
export const HOLD_MUSIC_DELAY_MS = 25_000;
//# sourceMappingURL=sounds.js.map